import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import {EGoogleTagManagerEventType} from '../../IGoogleTagManager';
import EventModel from '../EventModel';
import UserInfoModel from './models/UserInfoModel';

/**
 * Represents UserInfoEventModel
 */
export default class UserInfoEventModel extends EventModel {
	public userInfo: UserInfoModel;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const customer = data.customer;

		if (customer) {
			const userInfoModel = new UserInfoModel(managerRepository, customer);

			Object.assign(this, userInfoModel);
		}
	}

	/**
	 * Checks if event is persistent
	 * @returns {boolean} true if event is persistent
	 */
	public isPersistentEvent(): boolean {
		return true;
	}

	/**
	 * Checks if the event should be kept
	 * @param {any} data - event data
	 * @returns {boolean} true if event should be kept
	 */
	public isEventShouldBeKept(data: any): boolean {
		return EGoogleTagManagerEventType.CUSTOMER_CHANGED === data.event;
	}
};
